import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import ProgressBar from 'react-bootstrap/lib/ProgressBar';

import { getOverallProgress, ranks } from 'helpers/UserRank';

import styles from '../Onboarding.module.scss';

// Per-rank copy and styling for the profile-score column.
const RANK_CONTENT = {
  [ranks.LOW_RANK]: {
    pill: 'Getting started',
    pillClass: styles.rankStatusPillLow,
    label: 'Low',
    headline: 'Finish your profile to reach Medium',
    supporting:
      'A stronger profile means more client views. Work through the steps to move up a tier.',
    progressColour: 'danger',
  },
  [ranks.MEDIUM_RANK]: {
    pill: 'Halfway there',
    pillClass: styles.rankStatusPillMedium,
    label: 'Medium',
    headline: 'A few more steps to a high score',
    supporting:
      'High-scoring profiles appear higher in client searches. Finish the list to get there.',
    progressColour: 'warning',
  },
};

const RankProgressBar = ({ user, currentRank }) => {
  const content = RANK_CONTENT[currentRank];
  const currentProgress = getOverallProgress(user);

  if (!content) {
    return <span />;
  }

  return (
    <div className={styles.rankScoreColumn}>
      <span className={classNames(styles.rankStatusPill, content.pillClass)}>
        {content.pill}
      </span>

      <p className={styles.rankScoreLabel}>Your profile score</p>

      <ProgressBar
        now={currentProgress.now}
        max={currentProgress.max}
        label={content.label}
        className={styles.rankProgressBar}
        bsStyle={content.progressColour}
      />

      <h2 className={styles.rankHeadline}>{content.headline}</h2>
      <p className={styles.rankSupporting}>{content.supporting}</p>
    </div>
  );
};

RankProgressBar.propTypes = {
  user: PropTypes.object,
  currentRank: PropTypes.number,
};

export default RankProgressBar;
